export const API_ROOT =
  process.env.NODE_ENV === "development"
    ? "http://localhost:8888/"
    : "https://language-learning-server.onrender.com/";

export const isDev = process.env.NODE_ENV === "development";
